import { render, staticRenderFns } from "./info-modal.vue?vue&type=template&id=8ffd011c&scoped=true"
import script from "./info-modal.vue?vue&type=script&lang=js"
export * from "./info-modal.vue?vue&type=script&lang=js"
import style0 from "./info-modal.vue?vue&type=style&index=0&id=8ffd011c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd011c",
  null
  
)

export default component.exports